export const MapConstants = {
  FETCH_MAPS_REQUEST: 'FETCH_CHRONICLE_MAPS_REQUEST',
  FETCH_MAPS_SUCCESS: 'FETCH_CHRONICLE_MAPS_SUCCESS',
  FETCH_MAPS_FAILURE: 'FETCH_CHRONICLE_MAPS_FAILURE',

  FETCH_WORLD_MAPS_REQUEST: 'FETCH_WORLD_MAPS_REQUEST',
  FETCH_WORLD_MAPS_SUCCESS: 'FETCH_WORLD_MAPS_SUCCESS',
  FETCH_WORLD_MAPS_FAILURE: 'FETCH_WORLD_MAPS_FAILURE',

  UPLOAD_MAP_REQUEST: 'UPLOAD_MAP_REQUEST',
  UPLOAD_MAP_SUCCESS: 'UPLOAD_MAP_SUCCESS',
  UPLOAD_MAP_FAILURE: 'UPLOAD_MAP_FAILURE',

  EDIT_MAP_REQUEST: 'MODIFY_MAP_REQUEST',
  EDIT_MAP_SUCCESS: 'MODIFY_MAP_SUCCESS',
  EDIT_MAP_FAILURE: 'MODIFY_MAP_FAILURE',

  DELETE_MAP_REQUEST: 'DELETE_MAP_REQUEST',
  DELETE_MAP_SUCCESS: 'DELETE_MAP_SUCCESS',
  DELETE_MAP_FAILURE: 'DELETE_MAP_FAILURE',

  CREATE_MAP_REQUEST: 'CREATE_MAP_REQUEST',
  CREATE_MAP_SUCCESS: 'CREATE_MAP_SUCCESS',
  CREATE_MAP_FAILURE: 'CREATE_MAP_FAILURE',

  FETCH_MAP_REQUEST: 'FETCH_MAP_REQUEST',
  FETCH_MAP_SUCCESS: 'FETCH_MAP_SUCCESS',
  FETCH_MAP_FAILURE: 'FETCH_MAP_FAILURE',

  REFRESH_EVENTS_AND_MARKERS: 'REFRESH_EVENTS_AND_MARKERS',
};
